<template>
  <LayoutHeader main="reminder" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article>
      <form @submit.prevent="submit()" v-if="step == 'input'">
        <h1 class="text-center mb-4">パスワード再設定</h1>

        <div class="mb-3">
          <label for="email" class="form-label fw-bold">メールアドレス</label>
          <input type="email" class="form-control email" id="email" ref="email" v-model="email" readonly />
        </div>
        <div class="mb-3">
          <label for="password" class="form-label fw-bold">新しいパスワード</label>
          <input :type="passwordType" class="form-control" id="password" ref="password" v-model="password" placeholder="8文字以上を入力" autocomplete="new-password" minlength="8" @focus="passwordFocus()" @blur="passwordBlur()" required autofocus />
        </div>
        <div class="mb-5">
          <button type="submit" class="btn btn-danger w-100 fw-bold">再設定する</button>
        </div>
      </form>
      <div v-else-if="step == 'submited'">
        <h1 class="text-center">パスワードの再設定が完了しました</h1>

        <div class="mb-5 text-center">
          <i class="fad fa-check-circle" style="font-size:180px"></i>
        </div>
        <div class="mb-5 text-center">
          <router-link class="text-decoration-underline" :to="{ name: 'Top' }">ホームに戻る</router-link>
        </div>
      </div>
      <div v-else-if="step == 'invalidKey'">
        <h1 class="text-center">リマインダーは無効です</h1>

        <div class="mb-5 text-center">
          <a href="javascript:;" class="text-decoration-underline" @click.prevent="$refs.layout.passwordReminderModal = true">もう一度リマンダーを設定する</a>
        </div>
      </div>
    </article>
  </LayoutHeader>
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      titlePrefix: 'パスワード再設定',
      step: this.$route.query.step ?? 'input',
      password: '',
      email: this.$route.query.email,
    }
  },
  methods: {
    submit() {
      const data = {};
      data.email = this.email;
      data.password = this.password;
      data.key = this.$route.query.key;
      this.loadingOverlay = true;
      this.axios({
        method: 'post',
        url: '/reminder/change',
        data: data,
      }).then(async (r) => {
        this.loadingOverlay = false;
        if (r.data.error) {
          this.step = 'invalidKey';
          return;
        }
        this.step = 'submited';
        this.session(false);
      }).catch((e) => {
        alert('error');
        console.log(e);
        this.loadingOverlay = false;
      });
    },
    passwordFocus() {
      this.passwordType = 'text';
    },
    passwordBlur() {
      this.passwordType = 'password';
    },
  },
}
</script>


